import { DefaultSortOptionValues, DropdownSortOption } from '@shared/ui/dropdown-sort/types';

export const USER_BY_ALPHABET_SORT_OPTIONS: DropdownSortOption<DefaultSortOptionValues>[] = [
    {
        label: 'По умолчанию',
        value: null,
    },
    {
        label: 'По алфавиту от А-Я',
        value: DefaultSortOptionValues.Old,
    },
    {
        label: 'По алфавиту от Я-А',
        value: DefaultSortOptionValues.New,
    },
];
